import { Card, Switch, Text } from "@ttc3k/trekker";
import { cva, RecipeVariantProps } from "styled-system/css";
import { styled } from "styled-system/jsx";

const cardSurfaceStyles = cva({
  base: { bg: "white" },
  variants: {
    visual: {
      default: {},
      error: {
        borderColor: "border.error",
        color: "text.error.mid",
      },
    },
  },
  defaultVariants: {
    visual: "default",
  },
});

const CardSurface = styled(Card.Surface, cardSurfaceStyles);

type CardSurfaceProps = NonNullable<
  RecipeVariantProps<typeof cardSurfaceStyles>
>;

type SwitchCardProps = CardSurfaceProps & {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  title: string;
  subtitle?: string;
};

export const SwitchCard = ({
  checked,
  onCheckedChange,
  title,
  visual,
  subtitle = "",
}: SwitchCardProps) => {
  return (
    <CardSurface visual={visual}>
      <Card.Body>
        <Card.BodyContent alignItems={"center"}>
          {subtitle ? (
            <Card.Title mainText={title} subText={subtitle} />
          ) : (
            <Text visual={"bodySemiBold"} lineClamp={2} data-maintext>
              {title}
            </Text>
          )}
          <Switch
            checked={checked}
            onCheckedChange={(e) => onCheckedChange?.(e.checked)}
          />
        </Card.BodyContent>
      </Card.Body>
    </CardSurface>
  );
};
